import React from 'react';
import { awsRum } from '../rum';

interface PropsType {
  children: JSX.Element
}

export class AppInitWrapper extends React.Component<PropsType, {}> {
    private isInitialized = false;

    componentDidMount() {
        if (!this.isInitialized) {
            this.isInitialized = true;
            awsRum?.recordEvent('Initialization', { status: 'Success' });
        }
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        awsRum?.recordEvent('ErrorBoundary', {
            error: error.message,
            componentStack: info.componentStack,
        });
        awsRum?.recordError(error);
        throw error;
    }

    render() {
        return this.props.children;
    }
}

export default AppInitWrapper;
